export const getStockIssue = (item) => {
  if (item.isActive === false || item.isActive === 0) return 'This book is unavailable';
  const quantity = Number(item.quantity);
  const stock = item.stock == null ? NaN : Number(item.stock);
  if (!Number.isInteger(quantity) || quantity < 1) return 'Choose a valid quantity';
  if (!Number.isInteger(stock) || stock < 0) return 'Stock could not be verified';
  if (stock === 0) return 'Out of stock';
  if (quantity > stock) return `Only ${stock} available; reduce quantity`;
  return '';
};

export const getPurchaseIssue = (item, price = item.price) => {
  const stockIssue = getStockIssue(item);
  if (stockIssue) return stockIssue;
  if (price == null || price === '' || !Number.isFinite(Number(price)) || Math.round(Number(price) * 100) <= 0) {
    return 'Price currently unavailable';
  }
  return '';
};
